import { startsWithAlphanumeric, usedMoreThanAllowed } from './utils';
import { isValidNumber } from '../number';

import { ERRORS, PERSONALIZATION_CHARACTERS_COUNT_MIN, PERSONALIZATION_CHARACTERS_COUNT_MAX, PERSONALIZATION_INSTRUCTION_LENGTH_MAX } from '../../constants/validations';
import { ENABLED, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { EMPTY } from '../../constants';

export function getInstructionsError({ allowStartWithAnyCharacter, channel, value }) {
  if (!value.length) {
    return false;
  } else if (value.length > PERSONALIZATION_INSTRUCTION_LENGTH_MAX[channel]) {
    return ERRORS.PERSONALIZATION.LENGTH_EXCEEDED[channel];
  } else if (!allowStartWithAnyCharacter && !startsWithAlphanumeric(value)) {
    return ERRORS.PERSONALIZATION.ALPHANUMERIC_BEGIN;
  } else if (usedMoreThanAllowed({ patterns: [/\b\p{Lu}{3,}\b/], number: 1, value })) {
    return ERRORS.PERSONALIZATION.CAPITALIZED_WORDS_NUMBER_EXCEEDED;
  } else {
    return false;
  }
}

export function getCharactersCountError({ channel, value }) {
  return (
    (
      !isValidNumber(value) ||
      parseInt(value) !== parseFloat(value) ||
      value < PERSONALIZATION_CHARACTERS_COUNT_MIN[channel] ||
      value > PERSONALIZATION_CHARACTERS_COUNT_MAX[channel]
    ) && ERRORS.PERSONALIZATION.LIMIT_OUT_OF_RANGE[channel]
  );
}

export function validatePersonalization({ channel, personalization }) {
  let errors = EMPTY.MAP;

  if (personalization.get(ENABLED)) {
    const instructionsError = getInstructionsError({
      channel,
      value: personalization.getIn([ATTRIBUTE.INSTRUCTIONS, VALUE]),
    });

    if (instructionsError) {
      errors = errors.set(ATTRIBUTE.INSTRUCTIONS, instructionsError);
    }

    const charactersCountError = getCharactersCountError({
      channel,
      value: personalization.getIn([ATTRIBUTE.CHAR_COUNT_MAX, VALUE]),
    });

    if (charactersCountError) {
      errors = errors.set(ATTRIBUTE.CHAR_COUNT_MAX, charactersCountError);
    }
  }

  return errors;
}
